import App from './utils/App'

document.addEventListener('DOMContentLoaded', () => new App())
